import { render } from "./PageFormDokumenRingkasan.vue?vue&type=template&id=258ad6f0"
import script from "./PageFormDokumenRingkasan.vue?vue&type=script&lang=js"
export * from "./PageFormDokumenRingkasan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__